module.exports = __webpack_public_path__ + "img/belowNormal.1604f63b.svg";